import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, ViewChildren } from '@angular/core';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';

@Component({
  selector: 'app-adddepartment',
  templateUrl: './adddepartment.component.html',
  styleUrls: ['./adddepartment.component.css']
})
export class AdddepartmentComponent implements OnInit ,AfterViewInit {

  @ViewChildren('input')firstipcontrol;
 
  formname:String="Department"; 

//Display
formmode:string="Add";

//Mode Values
isaddmode:boolean=false;
iseditmode:boolean=false;
isdeletemode:boolean=false;
isviewmode:boolean=false;

isloading:boolean=false;
isprivilage:boolean=false;  
showProgress: boolean = false;
  
//Save Validation
submitted:boolean;
successfully:boolean;

//Edit Get Values
departmentColl:any=[];
departmentBO:any={};
departmentid:number=0

departmentform=new FormGroup({
  departmentid:new FormControl(0),          
  departmentname:new FormControl('',Validators.required),  
 inactive:new FormControl(false),  
});

@Input() ischild :boolean=false;
@Input() ischildadd :boolean=false;
@Input() ischildkey :number=0
@Output() childChanged = new EventEmitter<number>();


constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
   public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
     this.route.queryParams.subscribe(params => {
       if(params.id!==undefined){
         this.departmentid = params.id
       }          
     });

     this.fnServiceChanges();
}

 
fnServiceChanges(){
 this.loginService.serviceAuthChange.subscribe((value) => {
       if(this.loginService.fnCheckCompany()){
            if(this.fnCheckUserPririvilage()){
              this.isloading=true;
              this.fnOnInitForm();
            }
            else{
              this.fnUserFailedForm();
            }              
          }
          else{
            this.fnUserFailedForm();
          }              
    });
}



ngOnInit() {
  try{
    if(this.loginService.fnCheckCompany()){ 
      if(this.fnCheckUserPririvilage()){       
        this.isloading=true;
        this.fnOnInitForm();
      }
      else{
        this.fnUserFailedForm();
      }
    }
    else{
      this.loginService.fnGetUserRoleList();
    }
            
  }catch(ex){
    this.fnShowErrorMsg(ex);
  }
}

fnOnInitForm(){
   try{
       this.isaddmode=true;
       this.departmentform.reset();
       this.fnInitializeFormGroup(); 

       if(this.departmentid>0){
         this.fngetDepartment();
       }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
  }
  
  

fnCheckUserPririvilage(){
  var _check:boolean=false;
  if (this.departmentid>0){
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'ALTER')
  }else{
    _check= this.loginService.fnCheckUserRoleAction(this.formname,'CREATE')
  }

  return _check;
}

fnUserFailedForm(){
  this.isprivilage=true;
}



ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}

fnInitializeFormGroup(){
   this.departmentform.setValue({
    departmentid:0,    
    departmentname:'',
     inactive:false              
   })
}

//Get 
fngetDepartment() {        
    
    if(this.showProgress){
      return;
    }

    this.fnShowProgress();
    
     var data = {
       'departmentid':this.departmentid,
       'companyid':this.loginService.fnGetCompanyId()          
     }
     this.appService.getDepartment(data)
     .subscribe(
       (res)=>{                
         if (res.json().status === 200) {  
            this.fnHideProgress();
           this.departmentColl=res.json().result;
           var editdata = this.departmentColl[0];        
           this.fnEditMode(editdata);
           this.departmentBO=editdata;
         }
         else {
            this.fnHideProgress();
           this.loginService.fnAPIError(res.json())
         }
         
     },
       (err) => {     
        this.fnHideProgress();
       this.toastr.error('Error', err);
     })
}



//Save Btn Click
fnSaveBtnClick(){
   try{
     this.submitted=true;
     this.successfully=false;
     //Validate
     if(this.departmentform.valid){
         //Check
         var data = {
               'departmentid': this.departmentid,                      
               'departmentname':this.departmentform.get('departmentname').value, 
               'inactive':this.departmentform.get('inactive').value,            
               'companyid':this.loginService.fnGetCompanyId(),
               'createdby': this.loginService.fnGetModUserId(),  
              'modifiedby':this.loginService.fnGetModUserId(),                                                              
         }

       
         this.appService.fnCheckDepartment(data).subscribe(
           (res)=>{
             if(res.json().status===200){  
               var _checkresult=res.json().result[0].checkfield;
             
               if(_checkresult==="done"){
                     if (this.departmentform.get('departmentid').value>0){
                       //Update 
                       this.fnSetDepartment(data);
                     }
                     else{
                       //Insert 
                       this.fnInsertDepartment(data);
                     }
               }
               else{        
                     if(_checkresult==="name"){
                       this.departmentform.controls['departmentname'].setErrors({'notfound': true});
                     }
               }
             }
             else {
               this.loginService.fnAPIError(res.json())
             }
         },
         (err)=>{
             this.toastr.error('Error', err);           
         });
      }
   }catch(ex){
     this.fnShowErrorMsg(ex);
   }
}

//Insert
fnInsertDepartment(data){    
 
   this.appService.fnInsertDepartment(data).subscribe(
     (res)=>{
       if(res.json().status===200){  
         if(res.json().result!=""){

           this.ischildkey=res.json().result[0][0].deptid
           this.ischildadd=true;

           this.toastr.success('', "The new department has been added successfully.Insert Successfully");
           this.fnInsertActivityLog('INSERT', 0, data.departmentname);
           this.fnCloseForm();
         }
       }
       else {
         this.loginService.fnAPIError(res.json())
       }
   },
     (err)=>{
       this.toastr.error('Error', err);
     });

}

//Set
fnSetDepartment(data){    

this.appService.fnSetDepartment(data).subscribe(
 (res)=>{
   if(res.json().status===200){  
         if(res.json().result!=""){
             this.toastr.success('', "The department has been updated successfully.");
             this.fnInsertActivityLog('EDIT',this.departmentid,data.departmentname);
             this.fnCloseForm();        
         } 
     }
   else {
     this.loginService.fnAPIError(res.json())
   }
 },
 (err)=>{
   this.toastr.error('Error', err);
 });

}

//Close
fnCloseForm(){
try{

  if(this.ischild===false){
    this.router.navigate(['/Department']);
  }
  else{
    var pBO:any={
      isadd:this.ischildadd,
      childkey:this.ischildkey,
      doctype:'DEPARTMENT'    
    }
    this.childChanged.emit(pBO);
  }


}catch(ex){
   this.fnShowErrorMsg(ex);
}
}

private fnEditMode(deptBO){
 this.departmentform.setValue({ 
    departmentid:deptBO.departmentid,     
    departmentname:deptBO.departmentname,
   inactive:deptBO.inactive
 });

 this.formmode="Edit";
   
 this.iseditmode=true;
 this.isdeletemode=false;
 this.isviewmode=false;
}

fnInsertActivityLog(action,refno,desc){
  try{
    var data={
      logtype:action,
      logat:this.formname,
      refnum:refno,
      logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
      logby:this.loginService.fnGetModUserId(),
    }
  

    this.appService.fnInsertActivity(data).subscribe(
      (res)=>{
      },
      (err)=>{
     
      });

  }catch{

  }
  }
 
  

   

private fnShowProgress(){
  this.showProgress=true;
}
private fnHideProgress(){
  this.showProgress=false;
}


private  fnShowErrorMsg(ex){
this.toastr.warning('Internal Error', ex);       
}






}
